<template>
  <router-view></router-view>
</template>
<script>
import RegisterStoreModule from '@/mixins/RegisterStoreModule'
import reconcileStore from './store.js'

export default {
  name: 'reconcile',
  mixins: [RegisterStoreModule],
  created() {
    this.registerStoreModule('reconcile', reconcileStore)
  },
}
</script>
